// extracted by mini-css-extract-plugin
export default {"clearing":"InnerIcon_clearing__TRN+P"};